import { useSelector } from 'react-redux';

function useCheckRole(role: string) {
  const getCurrentRoles = useSelector(
    (state: any) => state.getTherapistProfileReducer.response?.data?.currentRoles
  );

  const checkRoleOfUser = () => {
    if (!getCurrentRoles) return false;
    return getCurrentRoles?.includes(role);
  };

  return [checkRoleOfUser()];
}

export default useCheckRole;
